import ActivityCategory from '@/ecm/variables/ActivityCategory';
import store from '@/store';

const ActivityUtils = {
  get activitiesList() {
    const isSuperAdmin = store.getters['account/user'].IsAdmin;

    const superAdminActivities = [
      ActivityCategory.DataManagementJob,
      ActivityCategory.AutoImportJob,
      ActivityCategory.AlertsJob,
      ActivityCategory.DelegationsJob,
      ActivityCategory.ConnectedServicesJob,
      ActivityCategory.DocumentLifeCycleJob,
      ActivityCategory.DocumentsWithMissingIndexesJob,
      ActivityCategory.LicenseJob,
      ActivityCategory.ObjectUnlockerJob,
      ActivityCategory.UsedDiskSpaceJob,
    ];

    const adminActivities = [
      ActivityCategory.EmailFailure,
      ActivityCategory.EmailSuccess,
      ActivityCategory.DataManagementJob,
      ActivityCategory.AutoImportJob,
      ActivityCategory.ConnectedServicesJob,
      ActivityCategory.DocumentAIRecognition,
    ];

    const allowedActivities = isSuperAdmin
      ? superAdminActivities
      : adminActivities;

    return Object.entries(ActivityCategory)
      .filter(([key, value]) => isNaN(Number(key)))
      .filter(([key, value]) => allowedActivities.includes(value))
      .map(([key, value]) => ({
        text: `Management.${key}`,
        value: value
      }));
  }
};

export default ActivityUtils;
